module.exports = __webpack_public_path__ + "static/media/slp.edf35150.png";